import { BASE, COLOR, COLUMN, FORMATTING, JARGON, PATH } from "../../modules/constants"
import { addPaddingRightToLastCell, getCellWithTooltip, headCell } from "../../modules/table.funcs"
import { buildTooltipTitle, getAge, getStatusLevel } from "../../modules/utilities"

const { dobMonYear, left, number, right, string } = FORMATTING

//#region header
const starHead = headCell({ id: COLUMN.STAR })

export const createFavouriteCompaniesHeaderData = ({ portrait }) => {
    const company = headCell({ id: COLUMN.COMPANY, align: left, label: "Company" })
    const location = headCell({ id: COLUMN.LOCATION, label: "Location" })
    const number = headCell({ id: COLUMN.NUMBER, label: "Number" })
    const status = headCell({ id: COLUMN.STATUS, label: "Status" })

    const cells = portrait
        ? [starHead, company, location]
        : [starHead, company, number, status, location]

    addPaddingRightToLastCell(cells)

    return cells
}

export const createFavouritePeopleHeaderData = ({ portrait }) => {
    const age = headCell({ id: COLUMN.AGE, label: "Age" })
    const dob = headCell({ id: COLUMN.DOB, label: "Date of Birth" })
    const officer = headCell({ id: COLUMN.OFFICER, align: left, label: "Name" })
    const residence = headCell({ id: COLUMN.RESIDENCE, label: JARGON.RESIDENCE })

    const cells = portrait
        ? [starHead, officer, residence]
        : [starHead, officer, dob, age, residence]

    addPaddingRightToLastCell(cells)

    return cells
}
//#endregion header

//#region Rows
export const createFavouriteCompaniesRowData = ({ items, portrait }) => {
    const rows = []

    items.forEach((item, index) => {

        const companyStatus = item.keyValues["companyStatus"]
        const companyNumber = item.keyValues["companyNumber"]

        const tooltipElements = portrait
            ? [companyNumber && `Reg. no. ${companyNumber}`, `status: ${companyStatus}`]
            : [""]

        const tooltip = buildTooltipTitle(tooltipElements)
        const statusColor = getStatusLevel(companyStatus)

        const name = getCellWithTooltip({
            tooltip,
            type: string,
            value: item.keyValues["title"],
        })

        const number = getCellWithTooltip({
            align: right,
            tooltip,
            type: string,
            value: companyNumber,
        })

        const status = getCellWithTooltip({
            align: right,
            color: COLOR[statusColor],
            tooltip,
            type: string,
            value: companyStatus,
        })

        const address = getCellWithTooltip({
            align: right,
            tooltip,
            type: string,
            value: item.keyValues["shortAddress"],
        })

        const cellWithTooltips = portrait
            ? [name, address]
            : [name, number, status, address] // landscape

        addPaddingRightToLastCell(cellWithTooltips)

        const row =
        {
            _id: item._id,
            category: item.keyValues["category"],
            cellWithTooltips,
            ids: item.ids,
            index,
            isFavourite: item.isFavourite,
            link: getLink(item),
            title: item.keyValues["title"],
        }

        rows.push(row)
    })
    return rows
}

export const createFavouritePeopleRowData = ({ items, portrait }) => {
    const rows = []

    items.forEach((item, index) => {
        const { _id, ids, keyValues, isFavourite } = item
        const name = getCellWithTooltip({
            sortValue: keyValues.name.toSort,
            type: string,
            value: keyValues.name.toPresent,
        })

        const dateOfBirth = getCellWithTooltip({
            sortValue: dobSortValue(keyValues.dateOfBirth),
            type: dobMonYear,
            value: keyValues.dateOfBirth,
        })

        const age = getCellWithTooltip({
            type: number,
            value: getAge(keyValues.dateOfBirth),
        })

        const address = getCellWithTooltip({
            align: right,
            type: string,
            value: keyValues.countryOfResidence || keyValues.shortAddress,
        })

        const cellWithTooltips = portrait
            ? [name, address] // portrait
            : [name, dateOfBirth, age, address] // landscape

        addPaddingRightToLastCell(cellWithTooltips)

        const row =
        {
            _id,
            category: keyValues.category,
            cellWithTooltips,
            ids,
            index,
            isFavourite,
            link: getLink(item),
            title: keyValues.title,
        }

        rows.push(row)
    })

    return rows
}

const dobSortValue = dateOfBirth => dateOfBirth
    ? new Date(`${dateOfBirth.year}-${dateOfBirth.month}`)
    : new Date("999")

const getLink = item => {
    const category = item.category || item.keyValues["category"]
    const idsStr = item.ids.join(',')
    if (!idsStr && category === 'company')
        return `/${PATH[BASE.ADVISER]}/${item._id}`
    return `/${category}/${idsStr}`
}
//#endregion rows

